<div class="site-dropdown" (click)="onOpenDropdown()"
     [ngClass]="{'focus': dropdownIsVisible, 'disabled': !!formControl?.disabled}">
  <label *ngIf="selectedSite && initialised">{{ displayValue }}</label>
  <label class="placeholder" *ngIf="!selectedSite && initialised">{{ placeholder }}</label>
  <label *ngIf="!initialised"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></label>

  <a class="arrow"><i class="far fa-angle-down" aria-hidden="true"></i></a>
  <a class="clear-selection" (click)="onClearSelection($event, true)" *ngIf="clearable && selectedSite && !formControl.disabled"><i class="far fa-times"
                                                                                              aria-hidden="true"></i></a>

  <div class="autocomplete-dropdown" *ngIf="dropdownIsVisible">
    <div class="autocomplete-search">
      <div [formGroup]="filterForm" class="form-group">
        <input #searchTermInput formControlName="searchTerm" type="text" (click)="$event.stopPropagation();">
      </div>

      <i class="far fa-search" aria-hidden="true"></i>
    </div>

    <p *ngIf="searchHasValue && filteredSites.length === 0">No patients found!</p>

    <div class="loading" *ngIf="isLoading">
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    </div>

    <div *ngIf="filteredSites.length > 0 && isLoading === false" class="patient-results">
      <ul>
        <li *ngFor="let site of filteredSites" [id]="site.id">
          <a (click)="onSelectSite(site)">
            <span class="site-number-consumer">
              <span class="badge badge-info site-consumer-name"
                    *ngIf="site.apiConsumerName && siteConsumerNameVisible">{{ site.apiConsumerName }}</span>
              <span class="site-number" *ngIf="site.trialSiteNumber && siteNumberVisible">{{ site.trialSiteNumber }}</span>
            </span>
            <span class="site-name" *ngIf="site.name && siteNameVisible">{{ site.name }}</span>
            <span class="site-address" *ngIf="site.address && siteAddressVisible">{{ site.address }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
